import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index10.css';const container = "_container_szgf3_1";
const disabled = "_disabled_szgf3_12";
const text = "_text_szgf3_18";
const label = "_label_szgf3_23";
const caption = "_caption_szgf3_33";
const s = {
  container,
  disabled,
  text,
  label,
  caption
};
const ControlContainer = forwardRef(
  ({
    className,
    children,
    label: label2,
    caption: caption2,
    disabled: disabled2,
    textClassName,
    labelClassName,
    captionClassName,
    childrenSide = "start",
    ...rest
  }, ref) => {
    return /* @__PURE__ */ jsxs("label", { ...rest, className: clsx(s.container, { [s.disabled]: disabled2 }, className), ref, children: [
      childrenSide === "start" && children,
      (label2 || caption2) && /* @__PURE__ */ jsxs("div", { className: clsx(s.text, textClassName), children: [
        /* @__PURE__ */ jsx("span", { className: clsx(s.label, labelClassName), children: label2 }),
        /* @__PURE__ */ jsx("span", { className: clsx(s.caption, captionClassName), children: caption2 })
      ] }),
      childrenSide === "end" && children
    ] });
  }
);
export {
  ControlContainer
};
